/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AreaResponse } from '../models/area-response';
import { deleteApiAreaV1Id } from '../fn/area/delete-api-area-v-1-id';
import { DeleteApiAreaV1Id$Params } from '../fn/area/delete-api-area-v-1-id';
import { getApiAreaV1Id$Json } from '../fn/area/get-api-area-v-1-id-json';
import { GetApiAreaV1Id$Json$Params } from '../fn/area/get-api-area-v-1-id-json';
import { getApiAreaV1Id$Plain } from '../fn/area/get-api-area-v-1-id-plain';
import { GetApiAreaV1Id$Plain$Params } from '../fn/area/get-api-area-v-1-id-plain';
import { GetAreasResponse } from '../models/get-areas-response';
import { postApiAreaV1$Json } from '../fn/area/post-api-area-v-1-json';
import { PostApiAreaV1$Json$Params } from '../fn/area/post-api-area-v-1-json';
import { postApiAreaV1$Plain } from '../fn/area/post-api-area-v-1-plain';
import { PostApiAreaV1$Plain$Params } from '../fn/area/post-api-area-v-1-plain';
import { postApiAreaV1Create$Json } from '../fn/area/post-api-area-v-1-create-json';
import { PostApiAreaV1Create$Json$Params } from '../fn/area/post-api-area-v-1-create-json';
import { postApiAreaV1Create$Plain } from '../fn/area/post-api-area-v-1-create-plain';
import { PostApiAreaV1Create$Plain$Params } from '../fn/area/post-api-area-v-1-create-plain';
import { putApiAreaV1Id$Json } from '../fn/area/put-api-area-v-1-id-json';
import { PutApiAreaV1Id$Json$Params } from '../fn/area/put-api-area-v-1-id-json';
import { putApiAreaV1Id$Plain } from '../fn/area/put-api-area-v-1-id-plain';
import { PutApiAreaV1Id$Plain$Params } from '../fn/area/put-api-area-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class AreaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiAreaV1()` */
  static readonly PostApiAreaV1Path = '/private/v1/areas';

  /**
   * Retrieves all areas.
   *
   * Retrieves all areas.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAreaV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1$Plain$Response(params?: PostApiAreaV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAreasResponse>> {
    return postApiAreaV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all areas.
   *
   * Retrieves all areas.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAreaV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1$Plain(params?: PostApiAreaV1$Plain$Params, context?: HttpContext): Observable<GetAreasResponse> {
    return this.postApiAreaV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAreasResponse>): GetAreasResponse => r.body)
    );
  }

  /**
   * Retrieves all areas.
   *
   * Retrieves all areas.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAreaV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1$Json$Response(params?: PostApiAreaV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAreasResponse>> {
    return postApiAreaV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all areas.
   *
   * Retrieves all areas.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAreaV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1$Json(params?: PostApiAreaV1$Json$Params, context?: HttpContext): Observable<GetAreasResponse> {
    return this.postApiAreaV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAreasResponse>): GetAreasResponse => r.body)
    );
  }

  /** Path part for operation `getApiAreaV1Id()` */
  static readonly GetApiAreaV1IdPath = '/private/v1/areas/{id}';

  /**
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAreaV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAreaV1Id$Plain$Response(params: GetApiAreaV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
    return getApiAreaV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAreaV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAreaV1Id$Plain(params: GetApiAreaV1Id$Plain$Params, context?: HttpContext): Observable<AreaResponse> {
    return this.getApiAreaV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaResponse>): AreaResponse => r.body)
    );
  }

  /**
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAreaV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAreaV1Id$Json$Response(params: GetApiAreaV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
    return getApiAreaV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * Retrieves the details of an area by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAreaV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAreaV1Id$Json(params: GetApiAreaV1Id$Json$Params, context?: HttpContext): Observable<AreaResponse> {
    return this.getApiAreaV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaResponse>): AreaResponse => r.body)
    );
  }

  /** Path part for operation `putApiAreaV1Id()` */
  static readonly PutApiAreaV1IdPath = '/private/v1/areas/{id}';

  /**
   * Updates an existing area.
   *
   * Updates an existing area.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiAreaV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAreaV1Id$Plain$Response(params: PutApiAreaV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
    return putApiAreaV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing area.
   *
   * Updates an existing area.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiAreaV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAreaV1Id$Plain(params: PutApiAreaV1Id$Plain$Params, context?: HttpContext): Observable<AreaResponse> {
    return this.putApiAreaV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaResponse>): AreaResponse => r.body)
    );
  }

  /**
   * Updates an existing area.
   *
   * Updates an existing area.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiAreaV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAreaV1Id$Json$Response(params: PutApiAreaV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
    return putApiAreaV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing area.
   *
   * Updates an existing area.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiAreaV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAreaV1Id$Json(params: PutApiAreaV1Id$Json$Params, context?: HttpContext): Observable<AreaResponse> {
    return this.putApiAreaV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaResponse>): AreaResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiAreaV1Id()` */
  static readonly DeleteApiAreaV1IdPath = '/private/v1/areas/{id}';

  /**
   * Deletes an area by its unique identifier (ID).
   *
   * Deletes an area by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiAreaV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAreaV1Id$Response(params: DeleteApiAreaV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiAreaV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an area by its unique identifier (ID).
   *
   * Deletes an area by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiAreaV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAreaV1Id(params: DeleteApiAreaV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiAreaV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiAreaV1Create()` */
  static readonly PostApiAreaV1CreatePath = '/private/v1/areas/create';

  /**
   * Creates a new area and returns the created entity.
   *
   * Creates a new area and returns the created entity.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAreaV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1Create$Plain$Response(params?: PostApiAreaV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
    return postApiAreaV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new area and returns the created entity.
   *
   * Creates a new area and returns the created entity.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAreaV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1Create$Plain(params?: PostApiAreaV1Create$Plain$Params, context?: HttpContext): Observable<AreaResponse> {
    return this.postApiAreaV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaResponse>): AreaResponse => r.body)
    );
  }

  /**
   * Creates a new area and returns the created entity.
   *
   * Creates a new area and returns the created entity.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAreaV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1Create$Json$Response(params?: PostApiAreaV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
    return postApiAreaV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new area and returns the created entity.
   *
   * Creates a new area and returns the created entity.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAreaV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAreaV1Create$Json(params?: PostApiAreaV1Create$Json$Params, context?: HttpContext): Observable<AreaResponse> {
    return this.postApiAreaV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaResponse>): AreaResponse => r.body)
    );
  }

}
